<div class="main-content">
  <div class="row">
    <div class="col-12">
      <div class="panel">
        <div class="panel-header d-flex justify-content-between align-items-center">
          <h5>Attribute Management</h5>
          @if (isEditMode) {
            <button class="btn btn-sm btn-outline-secondary" (click)="resetForm()">
              <i class="fa fa-plus me-1"></i> Create New Attribute
            </button>
          }
        </div>
        <div class="panel-body">
          <div class="row">
            <!-- Left Side: Add/Edit Attribute -->
            <div class="col-md-5">
              <div class="card border-0 shadow-sm">
                <div class="card-header bg-white">
                  <h6 class="mb-0">{{ isEditMode ? 'Edit Attribute: ' + selectedAttribute.name : 'Create New Attribute' }}</h6>
                </div>
                <div class="card-body">
                  <form [formGroup]="attributeForm">
                    <div class="mb-3">
                      <label class="form-label">Attribute Name</label>
                      <input type="text" formControlName="name" class="form-control" placeholder="e.g., Color, Size">
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Type</label>
                      <select formControlName="type" class="form-select">
                        <option value="text">Text</option>
                        <option value="color">Color</option>
                        <option value="color_swatch">Color Swatch</option>
                      </select>
                    </div>

                    <div class="attribute-values-section mt-4">
                      <label class="form-label d-flex justify-content-between">
                        Values
                        <span class="badge bg-secondary">{{ attributeValues.length }}</span>
                      </label>
                      
                      <div class="input-group mb-2">
                        <input type="text" [(ngModel)]="newValue.value" [ngModelOptions]="{standalone: true}" 
                               class="form-control form-control-sm" placeholder="Value (e.g. Red)">
                        @if (attributeForm.get('type')?.value !== 'text') {
                          <input type="text" [(ngModel)]="newValue.meta" [ngModelOptions]="{standalone: true}" 
                                 class="form-control form-control-sm" placeholder="Meta (e.g. #FF0000)">
                        }
                        <button class="btn btn-sm btn-primary" type="button" (click)="addValueToLocalList()">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>

                      <div class="list-group list-group-flush border rounded" style="max-height: 250px; overflow-y: auto;">
                        @for (v of attributeValues; let i = $index; track i) {
                          <div class="list-group-item d-flex justify-content-between align-items-center p-2">
                            <div>
                              <span class="fw-medium">{{ v.value }}</span>
                              @if (v.meta) {
                                <small class="text-muted ms-2">({{ v.meta }})</small>
                                @if (attributeForm.get('type')?.value !== 'text') {
                                  <span class="ms-1 border border-secondary rounded-circle d-inline-block" 
                                        [style.background-color]="v.meta" style="width: 12px; height: 12px;"></span>
                                }
                              }
                            </div>
                            <button type="button" class="btn btn-link btn-sm text-danger p-0" (click)="removeValueFromLocalList(i)">
                              <i class="fa fa-times"></i>
                            </button>
                          </div>
                        }
                        @if (attributeValues.length === 0) {
                          <div class="list-group-item text-center text-muted small py-3">No values added yet.</div>
                        }
                      </div>
                    </div>

                    <div class="mt-4">
                      <button type="button" class="btn btn-primary w-100" [disabled]="attributeForm.invalid || attributeValues.length === 0" (click)="saveAttribute()">
                        {{ isEditMode ? 'Update Attribute' : 'Create Attribute' }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- Right Side: Existing Attributes List -->
            <div class="col-md-7">
              <div class="card border-0 shadow-sm">
                <div class="card-header bg-white d-flex justify-content-between align-items-center">
                  <h6 class="mb-0">Existing Attributes</h6>
                  @if (isLoading) {
                    <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                  }
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0">
                      <thead class="bg-light">
                        <tr>
                          <th>Name</th>
                          <th>Type</th>
                          <th>Values</th>
                          <th class="text-end">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (attr of attributes; track attr.id) {
                          <tr [class.table-primary]="selectedAttribute?.id === attr.id">
                            <td class="fw-medium">{{ attr.name }}</td>
                            <td><span class="badge bg-light text-dark border">{{ attr.type }}</span></td>
                            <td>
                              <div class="d-flex flex-wrap gap-1">
                                @for (v of attr.values?.slice(0, 5); track v.id) {
                                  <span class="badge bg-info text-white" style="font-size: 0.7rem;">{{ v.value }}</span>
                                }
                                @if (attr.values?.length > 5) {
                                  <span class="badge bg-secondary" style="font-size: 0.7rem;">+{{ attr.values.length - 5 }}</span>
                                }
                              </div>
                            </td>
                            <td class="text-end">
                              <button class="btn btn-sm btn-outline-primary me-1" (click)="editAttribute(attr)">
                                <i class="fa fa-edit"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-danger" (click)="deleteAttribute(attr.id)">
                                <i class="fa fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        }
                        @if (attributes.length === 0 && !isLoading) {
                          <tr>
                            <td colspan="4" class="text-center py-4 text-muted">No attributes found.</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
